export default __webpack_public_path__ + "static/media/16.5d28b362.pdf";